// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"502":"servicios","900":"contacto","962":"home"}[chunkId] + "." + {"502":"04341fc2","900":"088bfd57","962":"bfc983c4"}[chunkId] + ".css";
};